import React from "react"
import styled from "styled-components"
import { up, down } from "styled-breakpoints"
import { MobileOnly, LaptopUpOnly } from "@utils/MediaQueries"
import Option from "./Option"
import OptionHeader from "./OptionHeader"
import SelectInput from "./SelectInput"
import colors from "@constants/colors"
import { columns } from "@constants/layout"
import {
  body,
  bodyBold,
  smallcaps,
  h5,
  subtextBold,
} from "@constants/typography"

const Options = styled.div`
  ${down("laptop")} {
    margin-bottom: 20px;
  }

  &.option-expanded .color-option {
    display: block;
  }
`

const OptionBody = styled.div`
  ${up("tablet")} {
    padding-left: 42px;
  }

  &:not(.color-option) {
    margin-bottom: 20px;
  }

  &.color-option {
    .mobile-title {
      ${bodyBold}
      color: ${colors.obsidian};
    }

    ${down("tablet")} {
      display: none;
      position: relative;

      &::before {
        content: "";
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 200;
      }
    }
  }
`
const OptionBodyWrapper = styled.div`
  flex-wrap: wrap;
  display: flex;
  padding: 20px 0 50px;

  ${down("tablet")} {
    display: block;
    border: 2px solid ${colors.lightestGray};
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 201;
    position: fixed;
    width: 100vw;
    top: 0px;
    left: auto;
    bottom: 0;
    right: 0px;
    margin: 0;
    background: #fff;
    padding: 10px;
    border-radius: 5px;
  }
`

interface OptionGroupProps {
  name: string
  count: number
  value: any
  optionValues: any
  availableOptions: any
  isExpaned: boolean
  hideDisabled?: boolean
  onSelectOption: (optionType) => void
  onSelectValue: (optionType, optionValue) => void
}

const OptionGroup: React.FC<OptionGroupProps> = ({
  onSelectOption,
  onSelectValue,
  isExpaned,
  count,
  value,
  name,
  optionValues,
  hideDisabled = false,
  availableOptions = [],
}) => {
  return (
    <Options
      className={isExpaned ? "option-expanded" : "option-collapsed"}
      id={"option-" + name}
    >
      <OptionHeader
        count={count}
        optionName={name}
        optionValue={value}
        onClick={() => {
          onSelectOption(name)
        }}
      />
      {optionValues[0].isColor ? (
        <OptionBody className="color-option">
          <OptionBodyWrapper>
            <MobileOnly className="mobile-title">Select {name}</MobileOnly>
            {optionValues.map((option: any, i) => (
              <Option
                key={`option-${name}-${i}`}
                selected={value && value === option.optionValue}
                imageSrc={option.image?.responsiveImage?.src}
                optionType={name}
                optionValue={option.optionValue}
                optionUnavailable={
                  availableOptions.length > 0 &&
                  availableOptions.indexOf(option.optionValue) === -1
                }
                onSelectOption={() => onSelectValue(name, option.optionValue)}
              />
            ))}
          </OptionBodyWrapper>
        </OptionBody>
      ) : (
        <OptionBody>
          <SelectInput
            name={name}
            label={name}
            autoSelect={true}
            value={value}
            hideDisabled={
              hideDisabled ||
              name === "Bracket" ||
              name === "Seat Options" ||
              name === "Options" ||
              name === "Year" ||
              name === "Trim"
            }
            options={optionValues}
            availableOptions={availableOptions}
            onChange={(e) => {
              onSelectValue(name, e.target.value)
            }}
            onSelectValue={onSelectValue}
          />
        </OptionBody>
      )}
    </Options>
  )
}

export default OptionGroup
